import { BaseController } from 'controllers/BaseController'
import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import { GetSelectableDeliveryTermsResponse } from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'
import { GetContext } from 'store/storeUtils'

export interface IDeliveryTermsAPI {
  getSelectableDeliveryTerms: () => Promise<GetSelectableDeliveryTermsResponse>
}

class DeliveryTermsAPI extends InternalAPI implements IDeliveryTermsAPI {
  constructor(partyId: string, onRequestChange: OnRequestChangeCallback) {
    super(`/api/parties/${partyId}/deliveryterms`, onRequestChange)
  }

  async getSelectableDeliveryTerms() {
    return this.GetAsync<GetSelectableDeliveryTermsResponse>({
      id: 'getSelectableDeliveryTerms',
      relativePath: '/selectable',
    })
  }
}

export class DeliveryTermsController extends BaseController<IDeliveryTermsAPI> {
  constructor() {
    super((onRequestChange: OnRequestChangeCallback) => {
      const { partyId } = GetContext()
      return new DeliveryTermsAPI(partyId, onRequestChange)
    })
  }

  async getSelectableDeliveryTerms() {
    try {
      return await this.api.getSelectableDeliveryTerms()
    } catch (err) {
      throw this.HandleError(err)
    }
  }
}
